/**
 * mock.ts (features/notifications), the bell's mock-mode fixture.
 *
 * One fixture entry (`freigabe_expired`) so the dropdown and that `describeNotification`
 * branch are renderable without a backend. Deliberately ONE: the badge shows «1» in mock
 * mode, the honest cost of a renderable bell. The `features/policies/mock.ts` convention,
 * imported behind `isLiveData()`; live mode never touches it.
 *
 * Payload mirrors what FreigabeExpiryService writes (ids only, rule #6):
 * `{ grant_id, comm_id }`, no subject, no addresses, no PII.
 *
 * [Source: apps/api/src/modules/communication/freigabe-expiry.service.ts]
 * [Source: apps/web/src/features/policies/mock.ts] (fixture-module convention)
 */
import type { NotificationsResponse } from '@brokly/shared';

export const NOTIFICATIONS_MOCK: NotificationsResponse = {
  notifications: [
    {
      id: 'ntf-freigabe-expired-1',
      type: 'freigabe_expired',
      payload: {
        grant_id: 'gr-7300-0001',
        comm_id: 'comm-7300-0001',
      },
      read_at: null,
      created_at: '2026-09-01T08:15:00.000Z',
    },
  ],
  unread_count: 1,
};
